import { useEffect } from "react";
import { Radio } from "lucide-react";

/** Genesys OAuth PKCE redirect landing page.
 *  Opened inside a popup by the "Connect Genesys" button. Extracts `code`
 *  and `state` from the query, forwards them to the opener via postMessage,
 *  then closes itself. The opener performs the backend token exchange.
 */
export default function GenesysCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const payload = {
      kind: "genesys-oauth-callback",
      code: params.get("code") || "",
      state: params.get("state") || "",
      error: params.get("error") || "",
      error_description: params.get("error_description") || "",
    };
    try {
      if (window.opener) {
        window.opener.postMessage(payload, window.location.origin);
      }
    } catch (_) {
      /* ignore cross-origin block */
    }
    // Give the opener 250ms to receive the message before closing.
    const t = setTimeout(() => {
      try { window.close(); } catch (_) { /* ignore */ }
    }, 250);
    return () => clearTimeout(t);
  }, []);

  return (
    <div className="min-h-screen grid place-items-center bg-slate-50 text-sm text-slate-500" data-testid="genesys-oauth-callback">
      <div className="flex items-center gap-3">
        <Radio className="w-4 h-4 text-emerald-600 animate-pulse" />
        Completing Genesys sign-in… you can close this window.
      </div>
    </div>
  );
}
